import { useNavigate } from "react-router-dom";
import { Button } from "../../../common/VFX-UI";
import useCampaignStyles from "./styles";
import { CampaignActionButtonProps } from "../../../../types";

const CampaignActionButton = (props: CampaignActionButtonProps) => {
  const navigate = useNavigate();
  const campaignStyles = useCampaignStyles();
  return (
    <Button
      style={campaignStyles.pledgeButton}
      onClick={() => navigate(`/pledge/${props.campaignId}`)}
    >
      {props.label}
    </Button>
  );
};

export default CampaignActionButton;
